import hmacSHA512 from 'crypto-js/hmac-sha512';

import { Configs } from '@/config';

export interface LoginRequestBody {
  username: string;
  password: string;
  timestamp: string;
}

/**
 * Build login request body (HMAC password + ISO timestamp), matching Kincode web clients.
 */
export function buildLoginBody(username: string, plainPassword: string): LoginRequestBody {
  if (!Configs.privateKey) {
    throw new Error('VITE_PRIVATE_KEY is required for password login');
  }

  return {
    username: username.trim(),
    password: hmacSHA512(plainPassword, Configs.privateKey).toString(),
    timestamp: new Date().toISOString(),
  };
}
